import { render, staticRenderFns } from "./MessageWidgetChannels.vue?vue&type=template&id=13def350&"
import script from "./MessageWidgetChannels.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports